import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { QaiBreadcrumbListComponent, QaiIconComponent, QaiBadgeComponent, BreadcrumbItem, QaiInnerWrapComponent, QaiSlotDirective, QaiMultiSelectComponent, QaiLabelComponent } from '@qai/ui';
import { ITeam } from 'src/app/interfaces/reportingV2/iteams';
import { EntityOption } from 'src/app/interfaces/reportingV2/ientity-option';
import { TranslocoService } from '@jsverse/transloco';
import { TranslationService } from 'src/app/services/translation.service';
import { LocaleService } from 'src/app/services/locale.service';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { TranslocoModule } from '@jsverse/transloco';
import { AccountEntityUtil } from 'src/app/utils/account-entity-util';
import { ReportingDashboardService } from 'src/app/services/reporting-dashboard/reporting-dashboard.service';
import { IModuleAssignmentStatsRequest } from 'src/app/interfaces/reportingV2/imodule-assignment-stats-request';
import { IModuleAssignmentStatsResponse } from 'src/app/interfaces/reportingV2/imodule-assignment-stats-response';

@Component({
  selector: 'app-certification-header',
  templateUrl: './certification-header.component.html',
  styleUrls: ['./certification-header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    QaiBreadcrumbListComponent,
    QaiLabelComponent,
    QaiIconComponent,
    QaiBadgeComponent,
    QaiInnerWrapComponent,
    QaiSlotDirective,
    QaiMultiSelectComponent
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'reportingV2',
    }
  ]
})
export class CertificationHeaderComponent implements OnInit, OnChanges {
  @Input() teamOptions: ITeam[] = [];
  @Input() selectedTeams: string[] = [];
  @Input() isLoadingTeams: boolean = false;
  @Input() accountUuid: string = '';
  @Input() moduleAssignmentUuid: string = '';
  @Output() teamChange = new EventEmitter<string[]>();

  isTranslationLoaded = false;
  isLoadingModuleStats = false;
  moduleStats: IModuleAssignmentStatsResponse | null = null;
  clearOption = { enable: true, label: 'Clear teams' };
  visibleOptionsMode = {
    enable: true,
    selectAllOption: { value: 'selectAll', label: 'Select all' },
    deselectAllOption: { value: 'deselectAll', label: 'Deselect all' }
  };
  searchOptions: EntityOption[] = [];

  constructor(
    private translocoService: TranslocoService,
    private translationService: TranslationService,
    protected readonly localeService: LocaleService,
    private reportingDashboardService: ReportingDashboardService,
  ) { }

  ngOnInit(): void {
    this.translationService.loadScopedTranslation('reportingV2').then(() => {
      this.isTranslationLoaded = true;
      this.searchOptions = AccountEntityUtil.formatEntities(this.teamOptions);
      this.clearOption.label = this.translocoService.translate(
        'CLEAR_TEAMS',
        {},
        'reportingV2'
      );
      this.visibleOptionsMode.selectAllOption.label =
        this.translocoService.translate('SELECT_ALL', {}, 'reportingV2');
      this.visibleOptionsMode.deselectAllOption.label =
        this.translocoService.translate( 'DESELECT_ALL', {}, 'reportingV2');
    });

    this.loadModuleAssignmentStats();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['teamOptions']) {
      this.searchOptions = AccountEntityUtil.formatEntities(this.teamOptions);
    }

  }

  private loadModuleAssignmentStats(): void {
    if (!this.accountUuid || !this.moduleAssignmentUuid) {
      console.warn('getModuleAssignmentStats: missing accountUuid or moduleAssignmentUuid', { accountUuid: this.accountUuid, moduleAssignmentUuid: this.moduleAssignmentUuid });
      return;
    }

    this.isLoadingModuleStats = true;
    const request: IModuleAssignmentStatsRequest = {
      accountUuid: this.accountUuid,
      moduleAssignmentUuid: this.moduleAssignmentUuid,
      teamUuids: this.selectedTeams,
    };

    this.reportingDashboardService.getModuleAssignmentStats(request).subscribe({
      next: (response) => {
        this.moduleStats = response;
        console.log('Module assignment stats loaded:', response);
        this.isLoadingModuleStats = false;
      },
      error: (error) => {
        console.error('Error loading module assignment stats:', error);
        this.isLoadingModuleStats = false;
      },
    });
  }

  getBreadcrumbItems(): BreadcrumbItem[] {
    return [
      { text: this.translocoService.translate('reportingV2.DASHBOARD'), href: '/reporting_dashboard' },
      { text: '', href: '', active: true }
    ];
  }

  onTeamChange(teams: string[]) {
    this.teamChange.emit(teams);
  }

  get formattedStartDate(): string {
    return this.moduleStats?.startDate ? this.localeService.formatDate(this.moduleStats.startDate) : '';
  }

  get formattedEndDate(): string {
    return this.moduleStats?.endDate ? this.localeService.formatDate(this.moduleStats.endDate) : '';
  }
}
